// extracted by mini-css-extract-plugin
export var colorBgPrimaryEight = "#612ecd";
export var colorBgPrimaryEleven = "#41c91f";
export var colorBgPrimaryFive = "#d14252";
export var colorBgPrimaryFour = "#d19b27";
export var colorBgPrimaryNine = "#d19b27";
export var colorBgPrimaryOne = "#612ecd";
export var colorBgPrimarySeven = "#00bcd6";
export var colorBgPrimarySix = "#006bb2";
export var colorBgPrimaryTen = "#006bb2";
export var colorBgPrimaryThree = "#41c91f";
export var colorBgPrimaryTwelwe = "#d14252";
export var colorBgPrimaryTwo = "#00bcd6";